<nb-card accent="primary">
  <nb-card-header>
    {{ "push_history" | translate }}
  </nb-card-header>
  <nb-card-body>
    <ngx-datatable
      *ngIf="history"
      class="ngx-datatable bootstrap"
      headerHeight="auto"
      rowHeight="auto"
      [rows]="history"
      [columns]="columns"
      [columnMode]="'force'"
      [limit]="historyLimit"
      [footerHeight]="50"
      [rowHeight]="50"
      (page)="setPage($event)"
    >
    </ngx-datatable>
  </nb-card-body>
</nb-card>

<!-- TableColumns Header -->
<ng-template #nameHdrTpl let-column="column">
  {{ column.name | translate }}
</ng-template>

<ng-template
  #detailsTemplate
  let-row="row"
  let-value="value"
  let-button="column.actions"
>
  <nb-icon
    class="action-icon"
    icon="activity-outline"
    [nbPopover]="statusTemplate"
    [nbPopoverPlacement]="'right'"
    [nbPopoverContext]="row"
    nbPopoverTrigger="hover"
  ></nb-icon>
  <nb-icon
    class="action-icon"
    icon="file-outline"
    [nbPopover]="payloadTemplate"
    [nbPopoverPlacement]="'right'"
    [nbPopoverContext]="row"
    nbPopoverTrigger="hover"
  ></nb-icon>
  <nb-icon
    class="action-icon"
    icon="code-outline"
    (click)="handleClickJSON(row)"
  ></nb-icon>
</ng-template>

<ng-template #statusTemplate let-row>
  <div class="primitive-overlay">
    <div><strong>Push Id: </strong>{{ row.id }}</div>
    <div>
      <strong>{{ "Success" | translate }}: </strong>
      <ul>
        <li>
          <strong>{{ "overall" | translate }}: </strong
          >{{ row.stats | statsSum : "successCount" }}
        </li>
        <li *ngFor="let prop of row.stats">
          <strong>{{ prop.appName }}: </strong>{{ prop.successCount }}
        </li>
      </ul>
    </div>
    <div>
      <strong>{{ "send_time" | translate }}</strong>
      <ul>
        <li>
          <strong>{{ "average" | translate }}: </strong
          >{{ row.stats | statsDurationAvg }} sec
        </li>
        <li *ngFor="let prop of row.stats | statsDuration">
          <strong>{{ prop.appName }}:</strong>{{ prop.duration }} sec
        </li>
      </ul>
    </div>
    <div *ngIf="hasExternalDuration">
      <strong
        >{{ "send_time" | translate }}
        {{ "external_services" | translate }}</strong
      >
      <ul>
        <ng-container *ngFor="let prop of row.stats | statsExtDuration">
          <li *ngIf="prop && prop.extDuration">
            <strong>{{ prop.serviceName }} - {{ prop.appName }}:</strong>
            {{ prop.extDuration }} sec
            <ng-container *ngIf="prop && prop.attempts">
              <ul>
                <li *ngFor="let attProp of prop.attempts">
                  <strong>Attempt {{ attProp.attempt }}:</strong>
                  {{ attProp.attempDuration }} sec / {{ attProp.failedCount }}
                  {{ "failed" | translate }}
                </li>
              </ul>
            </ng-container>
          </li>
        </ng-container>
      </ul>
    </div>
    <div>
      <strong>{{ "Error" | translate }}: </strong>
      <ul>
        <li>
          <strong>{{ "overall" | translate }}: </strong
          >{{ row.stats | statsSum : "errorCount" }}
        </li>
        <li *ngFor="let prop of row.stats">
          <strong>{{ prop.appName }}: </strong>{{ prop.errorCount }}
          <span *ngIf="prop.message">
            | {{ "message" | translate }}: {{ prop.message }}</span
          >
        </li>
      </ul>
    </div>
    <div>
      <strong>{{ "respond_no" | translate }}: </strong>
      <ul>
        <li>
          <strong>{{ "overall" | translate }}: </strong>
          {{ row.stats | statsSum : "noFeedbackCount" }}
        </li>
        <li *ngFor="let prop of row.stats">
          <strong>{{ prop.appName }}: </strong>{{ prop.noFeedbackCount }}
        </li>
      </ul>
    </div>
  </div>
</ng-template>

<ng-template #payloadTemplate let-row>
  <div class="primitive-overlay payloadPopup">
    <div
      *ngFor="let prop of flattenPayload(row.payload) | keyvalue"
      title="{{ prop.value }}"
    >
      <strong>{{ prop.key }}:</strong> {{ prop.value }}
    </div>
  </div>
</ng-template>

<ng-template #payloadDialog let-context let-ref="dialogRef">
  <nb-card accent="primary" size="large">
    <nb-card-header class="d-flex">
      <span class="mr-auto">{{ "payload" | translate }}</span>
      <nb-icon icon="close-outline" (click)="ref.close()"></nb-icon>
    </nb-card-header>
    <nb-card-body>
      <nb-accordion class="primitive-overlay payloadPopup">
        <nb-accordion-item>
          <nb-accordion-item-header>Incoming Payload:</nb-accordion-item-header>
          <nb-accordion-item-body>
            <pre>{{ parsePayload(context.payload) | json }}</pre>
          </nb-accordion-item-body>
        </nb-accordion-item>
        <nb-accordion-item *ngFor="let prop of context.stats">
          <nb-accordion-item-header
            >{{ prop.appName }}Payload:</nb-accordion-item-header
          >
          <nb-accordion-item-body *ngIf="prop.payload">
            <pre>{{ parsePayload(prop.payload) | json }}</pre>
          </nb-accordion-item-body>
          <nb-accordion-item-body *ngIf="!prop.payload">
            <pre>{{ "no_payload" | translate }}</pre>
          </nb-accordion-item-body>
        </nb-accordion-item>
      </nb-accordion>
    </nb-card-body>
  </nb-card>
</ng-template>
